import type { I18nDict } from '../types.ts'

export const ja: I18nDict = {
  app_name: 'ZION',
  settings_title: '設定',
  section_language: '言語',
  section_identity: 'ローカル ID',
  section_updates: 'アプリの更新',
  section_notifications: '通知',
  section_theme: '表示テーマ',
  section_backup: 'チャットのバックアップ',
  section_privacy_network: 'ネットワークのプライバシー',
  section_media: 'マルチメディア',
  section_security: 'セキュリティとパスワード',
  section_exit: '終了とデータの削除',
  toggle_external_links: '外部リンクの受信と表示',
  hint_external_links: 'OFF の場合：チャット内でリンクプレビューは表示されず、外部 URL は開けません（IP 追跡防止）。',
  toggle_auto_media: 'メディアとドキュメントの自動ダウンロード',
  hint_auto_media: 'OFF の場合：写真・動画・ファイルはバックグラウンドでダウンロードされません — チャット内で手動でタップしてください。',
  toggle_require_unlock: 'アプリ起動時にパスワードを要求',
  hint_require_unlock: 'ON の場合、ZION を開くたびにマスターパスワードが必要です。',
  toggle_wipe_exit: '終了時にデータを消去',
  hint_wipe_exit: 'ON の場合、アプリを閉じると一時 RAM キャッシュとセッションデータが消去されます。',
  btn_exit: '終了',
  btn_delete_all: 'すべてのデータを削除',
  btn_lock: 'アプリをロック',
  btn_back: '戻る',
  warn_disable_password_title: '⚠️ 警告',
  warn_disable_password_body: '起動時パスワードを無効にすると、この端末を持つ人なら誰でも暗号化されたメッセージを読めます。本当に続行しますか？',
  warn_delete_all_1: 'データベース全体を完全に削除しますか？この操作は取り消せません。',
  warn_delete_all_2: '最終確認：すべてのチャット、秘密鍵、設定が永久に削除されます。',
  link_blocked: '外部リンクがブロックされました（プライバシー設定）。',
  lang_welcome_title: 'ZION へようこそ',
  lang_welcome_sub: '言語を選択してください',
  lang_continue: '続行',
  settings_language_label: 'アプリの言語',
  auth_unlock_title: 'ロック解除',
  auth_or_password: '— またはパスワードで解除 —',
  auth_password_master: 'マスターパスワード',
  auth_unlock_btn: 'ロック解除',
  auth_verifying: '確認中…',
  auth_wrong_password: 'パスワードが正しくありません',
  auth_unlocked: 'ロック解除しました ✓',
  auth_access_title: 'ZION に参加',
  auth_beta_spots: '無料ベータ · 残り枠：',
  auth_beta_full: 'ベータは満員です（{max} ユーザー）。後でもう一度お試しください。',
  auth_beta_free: '無料ベータ · ライセンス不要',
  auth_or_create: '— または新しい ID を作成 —',
  auth_password_min: 'パスワード（8 文字以上）',
  auth_password_confirm: 'パスワードの確認',
  auth_privacy_check: '以下を読みました：',
  auth_privacy_link: 'プライバシーポリシー',
  auth_terms_check: '以下に同意します：',
  auth_terms_link: '利用規約',
  auth_password_local_hint: 'パスワードはこの端末から送信されません。サーバーアカウントはありません。',
  auth_create_identity: 'ID を作成',
  auth_accept_legal_err: '続行するにはプライバシーポリシーと利用規約に同意してください',
  auth_generating_keys: '鍵とセッションを生成中…',
  auth_generating_identity: '匿名 ID を生成中…',
  auth_generating_detail: 'ECDH 鍵 · ニックネーム · ソケットセッション · ZN- コード',
  auth_you_are: 'あなたは',
  auth_daily_suffix_hint: '日次サフィックスは UTC の日付が変わるたびに更新されます。ペアリングにはホーム画面の ZN- コードを使用してください。',
  auth_enter: 'ZION に入る',
  auth_starting: '起動中…',
  auth_restore_title: 'バックアップを復元',
  auth_restore_hint: '暗号化バックアップをお持ちですか？ID、連絡先、チャットを復元できます（キャッシュ削除後など）。',
  auth_restore_file: 'バックアップファイル（.enc / .enc.json）',
  auth_restore_pass: 'バックアップのパスフレーズ',
  auth_restore_pass_ph: 'エクスポート時に使用したパスフレーズ',
  auth_restore_btn: 'バックアップを復元',
  auth_restore_pick_file: 'バックアップファイル（.enc または .enc.json）を選択してください。',
  auth_restore_need_pass: 'パスフレーズを入力してください。',
  auth_restoring: '復元中…',
  auth_file_prefix: 'ファイル：',
  common_accept: '承認',
  common_reject: '拒否',
  common_cancel: 'キャンセル',
  common_accepting: '承認中…',
  common_error: 'エラー',
  common_loading: '読み込み中…',
  common_send: '送信',
  common_copied: 'コピーしました ✓',
  common_copy_failed: 'コピーに失敗しました',
  common_ok: 'OK',
  common_today: '今日',
  common_yesterday: '昨日',
  common_sending: '送信中…',
  home_zn_midnight_hint: 'UTC 0 時に変更されます（あと {h} 時間 {m} 分）',
  home_temp_empty: '時間限定チャットはありません。連絡先の ⏱ をタップして開始してください。',
  home_unread_aria: '{count} 件のメッセージ',
  home_temp_waiting: '承認待ち…',
  home_temp_expires: '時間限定チャット · 残り {remaining}',
  home_temp_cancel: 'キャンセル',
  home_temp_fallback_label: '時間限定チャット',
  home_temp_invite_title: '⏱ 時間限定チャットの招待',
  home_temp_invite_body: '{nick} が一時的なチャット（{duration}）を希望しています。',
  home_temp_invite_hint: '承認すると、期限切れで消えるメッセージのやり取りが始まります。',
  home_temp_accept: '承認',
  home_temp_reject: '拒否',
  home_temp_accepting: '承認中…',
  home_contacts_empty: '連絡先がありません。ZN- コードまたは QR を共有してペアリングしてください。',
  home_temp_chat_aria: '時間限定チャット',
  home_btn_pair_title: 'ペアリング',
  home_btn_settings_title: '設定',
  home_zn_title: '今日の ZN- コード',
  home_btn_copy_zn: 'ZN- をコピー',
  home_btn_open_pair: 'ペアリング QR',
  home_section_temp: '時間限定チャット',
  home_section_chat: 'チャット',
  home_loading: '読み込み中…',
  home_pair_zn_title: 'ZN- コードでペアリング',
  home_btn_zn_pair: 'リクエストを送信',
  home_copied: 'コピーしました ✓',
  home_copy_failed: 'コピーに失敗しました',
  home_pair_request_title: '連絡先リクエスト',
  home_pair_request_body: '{name} がチャットを希望しています。',
  home_pair_reject: '拒否',
  home_pair_accept: '承認',
  home_pair_accepting: '承認中…',
  home_pair_accept_failed: '承認に失敗しました',
  home_zn_digits_err: 'ZN- の後の 5 桁を入力してください。',
  home_sending: '送信中…',
  chat_rename: '名前を変更',
  chat_rename_matrix: '[名前変更]',
  chat_rename_title: '連絡先の名前を変更',
  chat_menu_title: 'チャットオプション',
  chat_loading: 'メッセージを読み込み中…',
  chat_reply_to: '返信先',
  chat_cancel_title: 'キャンセル',
  chat_voice_lock_hint: '上にスワイプして録音をロック',
  chat_voice_locked: '録音をロックしました — 完了をタップ',
  chat_voice_stop: '完了',
  chat_voice_stop_title: '完了',
  chat_voice_preview_label: '音声プレビュー — 送信前に再生',
  chat_voice_send: '送信',
  chat_voice_send_title: '送信',
  chat_timer_label: 'タイマー',
  chat_timer_title: 'メッセージタイマー',
  chat_timer_off: 'OFF',
  chat_timer_15s: '15 秒',
  chat_timer_30s: '30 秒',
  chat_timer_1m: '1 分',
  chat_timer_2m: '2 分',
  chat_photo: '写真',
  chat_photo_title: '写真',
  chat_voice_hold: '長押しで録音',
  chat_voice_hold_title: '長押しで録音',
  chat_doc: 'ドキュメント',
  chat_doc_title: 'ドキュメント',
  chat_attach_title: '添付',
  chat_input_placeholder: 'E2E 暗号化メッセージ…',
  chat_send: '送信',
  chat_rename_modal_title: '連絡先の名前を変更',
  chat_rename_nickname: 'ニックネーム：@{nick}',
  chat_rename_placeholder: 'カスタム名',
  chat_rename_cancel: 'キャンセル',
  chat_rename_save: '保存',
  chat_action_reply: '↩ 返信',
  chat_action_copy: '⎘ コピー',
  chat_action_delete_me: '🗑 自分のみ削除',
  chat_action_delete_all: '🗑 全員分削除',
  chat_action_cancel: 'キャンセル',
  chat_menu_clear_me: '🗑 チャットを消去（自分のみ）',
  chat_menu_clear_all: '🗑 全員分チャットを削除',
  chat_menu_cancel: 'キャンセル',
  chat_doc_send_title: 'ドキュメントを送信',
  chat_doc_default_name: 'document',
  chat_doc_send_hint: 'ファイルは圧縮され、E2E 暗号化されて送信されます。最大 5 MB。',
  chat_doc_cancel: 'キャンセル',
  chat_doc_send_encrypted: '暗号化して送信',
  chat_doc_too_large: '⚠️ ファイルが大きすぎます：ドキュメントのセキュリティ上限は 5 MB です。',
  chat_doc_unsupported: 'サポートされていないドキュメント形式です。',
  chat_copy_failed: 'コピーに失敗しました',
  chat_confirm_delete_me: 'このメッセージを自分のみ削除しますか？',
  chat_confirm_delete_all: 'このメッセージを全員分削除しますか？',
  chat_confirm_clear_all: 'チャット全体を全員分削除しますか？この操作は取り消せません。',
  chat_confirm_clear_me: 'チャットを自分のみ消去しますか？',
  chat_jump_new: '↓ 新着メッセージ',
  chat_empty: 'メッセージがありません。何か入力して始めましょう。',
  chat_voice_err_short: '音声メッセージが短すぎます（最低 1 秒）。',
  chat_voice_err_long: '音声メッセージが長すぎます（最大 2 分）。',
  chat_voice_err_large: '音声メッセージが大きすぎます（最大 3 MB）。',
  chat_voice_err_start: '音声録音を開始できませんでした。',
  chat_destroyed: '✉ メッセージを読み、破棄しました',
  chat_destroyed_title: 'メッセージを読み、破棄しました',
  chat_hold_options: '長押しでオプション',
  chat_reply_fallback: 'メッセージ',
  chat_timer_badge: '⏱ {seconds} 秒',
  chat_timer_badge_pending: '⏱ …',
  pair_zn_midnight_hint: 'ZN- コードは UTC 0 時に変更されます（あと {h} 時間 {m} 分）。',
  pair_copied: 'コピーしました ✓',
  pair_copy_failed: 'コピーに失敗しました',
  pair_title: 'ペアリング',
  pair_zn_title: '今日の ZN- コード',
  pair_btn_copy_zn: 'ZN- コードをコピー',
  pair_tab_mine: '自分の QR',
  pair_tab_scan: 'スキャン / ZN-',
  pair_qr_aria: 'ペアリング QR',
  pair_expires_in: '有効期限',
  pair_btn_copy_payload: 'ペイロードをコピー',
  pair_btn_regen_qr: 'QR を再生成',
  pair_qr_hint: 'この QR を相手の端末に見せてください。10 分間有効 — Android アプリと互換性があります。',
  pair_expired: '期限切れ',
  pair_contact_zn_title: '連絡先の ZN- コード',
  pair_zn_prefix_hint: '<strong>ZN-</strong> プレフィックスは設定済みです — 5 文字の英数字のみ入力してください。',
  pair_btn_zn_request: 'ZN- リクエストを送信',
  pair_paste_title: 'または ZION1:: QR を貼り付け',
  pair_paste_hint: '<code>ZION1::</code> ペイロードを貼り付けるか、QR の写真をアップロードしてください。',
  pair_paste_placeholder: 'ZION1::…',
  pair_btn_pick_qr: '写真 / カメラから',
  pair_btn_connect_qr: 'QR で接続',
  pair_zn_digits_err: 'ZN- の後の 5 桁を入力してください。',
  pair_sending: 'リクエストを送信中…',
  pair_reading_qr: 'QR を読み取り中…',
  pair_qr_not_found: '画像内に QR コードが見つかりません。',
  pair_zn_read_ok: 'ZN- コードを読み取りました — リクエストを送信で確認してください。',
  pair_qr_read_ok: 'QR を読み取りました — QR で接続で確認してください。',
  pair_qr_read_err: 'QR の読み取りエラー。',
  settings_identity_hint: 'パスワードと鍵はこのブラウザに保存されます。サーバーアカウントはありません。',
  settings_btn_add_home: 'ホーム画面に追加ガイド',
  settings_devices_title: 'リンク済み端末',
  settings_devices_hint: 'マルチデバイス Zero-Knowledge：鍵は E2E 暗号化で転送されます。サーバーは中継のみです。',
  settings_btn_link_device: '新しい端末をリンク',
  settings_btn_sync_pc: 'PC の履歴を同期',
  settings_no_devices: 'リンク済み端末がありません。',
  settings_device_self: 'この端末',
  settings_version_prefix: 'バージョン：',
  settings_ios_push_hint: '<strong>iPhone：</strong> 通知 = ホーム画面からの PWA + バナー/サウンド ON。ビルド ≥ <code>iospush7</code>。',
  settings_btn_force_update: 'アプリを強制更新',
  settings_updating: '更新中…',
  settings_push_mode_prefix: 'モード：',
  settings_push_hint_ios: '<strong>iPad/iPhone：</strong> 通知はホーム画面のアイコンから ZION を開いた場合のみ機能します（共有 → ホーム画面に追加）。通常の Safari では利用<em>できません</em> — iOS 17 でも同様です。ホーム画面に追加した後、ここに戻り「通知を有効にする」をタップしてください。',
  settings_btn_enable_push: 'プッシュ通知を有効にする',
  settings_btn_desktop_notify: 'デスクトップ通知（PC）',
  settings_btn_disable_push: '通知を無効にする',
  settings_desktop_requesting: 'デスクトップの許可を要求中…',
  settings_desktop_ok: 'デスクトップ通知が有効です（メッセージ受信時にサウンド + ポップアップ）。',
  settings_desktop_denied: '許可が拒否されたか、サポートされていません。',
  settings_push_no_session: 'セッションの準備ができていません。',
  settings_push_requesting: '許可を要求中…',
  settings_push_active: '通知が有効です。',
  settings_push_disabled: '通知が無効です。',
  settings_theme_hint: 'ZION Android アプリと同じテーマです。',
  settings_theme_recommended: 'おすすめ',
  settings_backup_hint: 'パスフレーズで暗号化された JSON ファイル（Android v2 形式と互換）。PC に保存してください：連絡先、チャット、Web ID。',
  settings_backup_pass_label: 'バックアップのパスフレーズ',
  settings_backup_pass_ph: '専用パスフレーズ（8 文字以上）',
  settings_btn_export_backup: 'バックアップをエクスポート',
  settings_backup_file_label: 'ファイルから復元',
  settings_backup_import_pass_label: 'バックアップのパスフレーズ',
  settings_backup_import_pass_ph: 'エクスポート時に使用したパスフレーズ',
  settings_btn_import_backup: 'バックアップを復元',
  settings_backup_file_prefix: 'ファイル：{name}',
  settings_backup_pass_min: 'パスフレーズは 8 文字以上必要です。',
  settings_backup_creating: 'バックアップを作成中…',
  settings_backup_pick_file: 'バックアップファイル（.enc または .enc.json）を選択してください。',
  settings_backup_need_pass: 'バックアップのパスフレーズを入力してください。',
  settings_backup_restoring: '復元中…',
  settings_backup_overwrite_confirm: 'ローカルデータを上書きしますか？',
  settings_modal_ok: 'OK',
  temp_duration_5m: '5 分',
  temp_duration_10m: '10 分',
  temp_duration_15m: '15 分',
  temp_duration_30m: '30 分',
  temp_duration_1h: '1 時間',
  temp_duration_6h: '6 時間',
  temp_duration_24h: '24 時間',
  temp_duration_7d: '7 日',
  temp_remaining_expired: '期限切れ',
  temp_remaining_days: '{days} 日 {hours} 時間',
  temp_remaining_hours: '{hours} 時間 {minutes} 分',
  temp_remaining_minutes: '{minutes} 分',
  temp_remaining_seconds: '{seconds} 秒',
  temp_screen_subtitle: '時間限定チャット · 一時メッセージ',
  temp_empty: '一時メッセージはありません。',
  temp_empty_hint: '一時メッセージを入力してください。タイマー期限切れで消えます。',
  temp_input_placeholder: '一時メッセージ…',
  temp_send: '送信',
  temp_waiting_accept: '{name} が時間限定チャットを承認するのを待っています…',
  temp_waiting_placeholder: '承認待ち…',
  temp_expires_in: '残り {remaining}',
  temp_duration_title: '時間限定チャット',
  temp_duration_with: '{name} と',
  temp_duration_hint: '期間を選択してください — チャットは両方の端末から消えます。',
  temp_sending_invite: '招待を送信中…',
  voice_lock_hint: '上にスワイプして録音をロック',
  voice_locked: '録音をロックしました — 完了をタップ',
  add_home_title: 'ホーム画面に追加（iPhone / iPad）',
  add_home_guide_title: 'Safari ガイド',
  add_home_step1: 'このページ（<code>zionyx.ch/app/</code>）で <strong>Safari</strong> を開く',
  add_home_step2: '<strong>共有</strong>（上向き矢印の四角）をタップ',
  add_home_step3: '<strong>ホーム画面に追加</strong> を選択',
  add_home_step4: 'Safari のタブではなく、<strong>アイコン</strong> から ZION を開く',
  add_home_hint: 'iOS/iPadOS 16.4 以降では、ホーム画面アプリで Web Push 通知とチャットキーボードが利用できます。インストール後、<strong>設定 → 通知を有効にする</strong> に進んでください。',
  add_home_btn_continue: '了解 — 続行',
  add_home_btn_skip: '今はスキップ',
  search_title: 'ZN- コードで検索',
  search_label: '日次 ZN- コード',
  search_placeholder: 'ZN-123456',
  search_btn: '検索',
  search_hint: '連絡先の ZN- コードを入力してください。ニックネーム検索はありません — ID はローカルのみです。',
  search_format_err: '形式：ZN-123456',
  search_resolving: 'コードを解決中…',
  search_invalid_code: '無効なコード — 最新の ZN- を確認してください（相手の端末で ZION を再起動）',
  search_session_found: 'セッションが見つかりました',
  search_tap_to_send: 'タップしてリクエストを送信',
  search_socket_not_ready: 'ソケットセッションの準備ができていません',
  search_request_sent: 'リクエストを送信しました ✓',
  search_request_failed: '送信に失敗しました',
  license_title: 'Web / iPhone ライセンスの有効化',
  license_heading: 'ライセンス',
  license_heading_updated: '更新された規約',
  license_hint: 'zionyx.ch で購入した <strong>ZION-XXXX-XXXX-XXXX</strong> コードを入力してください。このブラウザ（ローカル鍵）に紐付けられます。',
  license_code_label: 'ライセンスコード',
  license_code_placeholder: 'ZION-XXXX-XXXX-XXXX',
  license_btn_activate: 'ライセンスを有効化',
  license_beta_hint: 'Web ベータ：利用可能な場合は iPhone 専用ライセンスを使用してください。',
  license_accept_legal_err: '続行するにはプライバシーポリシーと利用規約に同意してください',
  license_need_code: 'ライセンスコードを入力してください',
  license_verifying: 'ライセンスを確認中…',
  license_invalid_or_used: '無効なライセンス、または別の端末で既に使用されています',
  license_active: 'ライセンス有効 ✓',
  license_err_not_found: '無効なライセンスコード',
  license_err_conflict: 'ライセンスは既に別の端末に紐付けられています',
  license_err_rate_limit: '試行回数が多すぎます — 1 分お待ちください',
  license_err_generic: 'ライセンスエラー',
  link_device_title: '新しい端末をリンク',
  link_device_hint: '<strong>PC</strong> で設定 → 新しい端末をリンクを開くと、<strong>緑の QR</strong> が表示されます。下でスキャンしてください（カメラまたは写真）。',
  link_device_status_ready: '[準備完了]',
  link_device_upload_label: 'QR 写真をアップロード',
  link_device_btn_camera: 'カメラ / ギャラリーを開く',
  link_device_placeholder: 'QR リンクまたはペイロード…',
  link_device_btn_send_vault: '暗号化ボルトを送信',
  link_device_err_invalid_qr: '無効または期限切れの QR です。',
  link_device_status_invalid: '[無効な QR]',
  link_device_status_sync_complete: '[同期完了]',
  link_device_status_transfer_failed: '[転送失敗]',
  link_device_status_qr_detected: '[QR 検出 — 転送中...]',
  link_device_status_tap_camera: '[緑のボタンをタップ — iPhone カメラ]',
  link_device_status_use_camera_below: '[下のカメラ / ギャラリーを使用]',
  link_device_status_point_camera: '[PC の QR にカメラを向けてください...]',
  link_device_status_decoding: '[QR をデコード中...]',
  link_device_status_qr_not_found: '[QR が見つかりません]',
  link_device_status_decode_failed: '[デコード失敗]',
  link_device_status_opened_from_qr: '[QR から開きました — 起動中...]',
  link_recv_title: 'スマホから連携',
  link_recv_hint_compact:
    'この<strong>緑の QR</strong>をスマホで読み取ってください（設定 → 新しいデバイスを連携）。ボルトはエンドツーエンド暗号化されます。',
  link_recv_hint_auth:
    'すでにスマホに ZION がありますか？この QR を<strong>カメラ</strong>で読み取ると、PC が連携して自動でログインします。',
  link_recv_qr_alt: 'デバイス連携 QR',
  link_recv_copy_link: 'リンクをコピー',
  link_recv_awaiting: '[スマホのスキャン待ち — トンネル開放中...]',
  link_recv_failed: '[連携失敗]',
  link_recv_tunnel_lost:
    'トンネルが切断されました — ボルトはまだ転送中の可能性があります。QR を再度スキャンしてください。',
  notify_title_prefix: 'ZION — {name}',
  notify_default_body: '新しい暗号化メッセージ',
  notify_temp_title_prefix: 'ZION ⏱ {name}',
  notify_temp_default_body: '一時メッセージ',
  force_update_title: '🚨 必須の重要アップデート — Zionyx を安全に使い続けるには、最新リリースをダウンロードする必要があります。',
  force_update_desc: 'インストール済みクライアントは、サーバーで要求されている最小バージョンと互換性がありません。',
  force_update_versions: 'インストール済み：v{current} · 必要：v{required}',
  force_update_btn: '今すぐ更新',
}
